import { render, staticRenderFns } from "./TableReportDetail.vue?vue&type=template&id=1ac1f6bb&scoped=true&"
import script from "./TableReportDetail.vue?vue&type=script&lang=js&"
export * from "./TableReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableReportDetail.vue?vue&type=style&index=0&id=1ac1f6bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1f6bb",
  null
  
)

export default component.exports